import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShieldAlt, faHandHoldingHeart, faChartLine } from '@fortawesome/free-solid-svg-icons';

const ServiceSection: React.FC = () => {
  return (
    <section className="section bg-light-gray" id="services">
      <Container>
        <h2 className="section-title">आमच्या सेवा</h2>
        <p className="section-subtitle">आपल्या विमा आणि आर्थिक गरजांसाठी सर्वसमावेशक उपाय</p>
        
        <Row className="g-4">
          <Col lg={4} md={6}>
            <Card className="h-100">
              <Card.Body className="text-center p-4">
                <div className="feature-icon">
                  <FontAwesomeIcon icon={faShieldAlt} />
                </div>
                <Card.Title>जीवन आधार विमा सेवा केंद्र</Card.Title>
                <Card.Text>
                  LIC कडून सर्वसमावेशक विमा सेवा जे आपल्या कुटुंबाचे संरक्षण करतात आणि भविष्यातील सुरक्षितता देतात. 
                  आमचे तज्ञ सल्लागार आपल्याला आपल्या गरजेनुसार योग्य विमा निवडण्यात मदत करतात.
                </Card.Text>
                <ul className="list-unstyled text-start">
                  <li>✓ जीवन विमा योजना</li>
                  <li>✓ गुंतवणूक नियोजन</li>
                  <li>✓ कुटुंब संरक्षण योजना</li>
                  <li>✓ निवृत्ती उपाय</li>
                </ul>
              </Card.Body>
              <Card.Footer className="bg-transparent border-0 text-center">
                <a href="/insurance" className="btn btn-primary">अधिक जाणून घ्या</a>
              </Card.Footer>
            </Card>
          </Col>
          
          <Col lg={4} md={6}>
            <Card className="h-100">
              <Card.Body className="text-center p-4">
                <div className="feature-icon">
                  <FontAwesomeIcon icon={faHandHoldingHeart} />
                </div>
                <Card.Title>जीवन आधार फाउंडेशन</Card.Title>
                <Card.Text>
                  समाजातील गरजू लोकांसाठी समर्पित, जीवन सुधारण्यासाठी कार्यरत संस्था. 
                  आम्ही सकारात्मक बदलासाठी आणि मजबूत समुदाय घडविण्यासाठी कठोर परिश्रम करतो.
                </Card.Text>
                <ul className="list-unstyled text-start">
                  <li>✓ समाजसेवा कार्यक्रम</li>
                  <li>✓ शैक्षणिक उपक्रम</li>
                  <li>✓ आरोग्य सेवा सहाय्य</li>
                  <li>✓ सामाजिक कल्याण प्रकल्प</li>
                </ul>
              </Card.Body>
              <Card.Footer className="bg-transparent border-0 text-center">
                <a href="/foundation" className="btn btn-primary">अधिक जाणून घ्या</a>
              </Card.Footer>
            </Card>
          </Col>
          
          <Col lg={4} md={6} className="mx-auto">
            <Card className="h-100">
              <Card.Body className="text-center p-4">
                <div className="feature-icon">
                  <FontAwesomeIcon icon={faChartLine} />
                </div>
                <Card.Title>जीवन आधार महिला ग्रामीण बिघरशेती पतसंस्था</Card.Title>
                <Card.Text>
                  ग्रामीण भागातील समाज आणि महिलांच्या सशक्तीकरणासाठी आर्थिक सेवा. 
                  आम्ही स्पर्धात्मक व्याजदरांवर सुलभ आर्थिक उपाय पुरवतो.
                </Card.Text>
                <ul className="list-unstyled text-start">
                  <li>✓ स्पर्धात्मक दरावर कर्जे</li>
                  <li>✓ महिला सशक्तीकरण कार्यक्रम</li>
                  <li>✓ ग्रामीण विकास उपक्रम</li>
                  <li>✓ आर्थिक साक्षरता शिक्षण</li>
                </ul>
              </Card.Body>
              <Card.Footer className="bg-transparent border-0 text-center">
                <a href="/finance" className="btn btn-primary">अधिक जाणून घ्या</a>
              </Card.Footer>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ServiceSection;
